import { createFileRoute } from '@tanstack/react-router';

import { PortalCompanyProfilePage } from '@/modules/portal/pages/PortalCompanyProfilePage';

export const Route = createFileRoute('/portal/company-profile/')({
  component: PortalCompanyProfilePage,
});
